var map = {
	"./ar.svg": "0859",
	"./de.svg": "b5d4",
	"./en.svg": "1a38",
	"./es.svg": "8c8d",
	"./fa.svg": "5ec4",
	"./fr.svg": "7ad2",
	"./it.svg": "46fe",
	"./ja.svg": "c449",
	"./ko.svg": "78df",
	"./pt.svg": "6b4e",
	"./ru.svg": "59b9",
	"./tr.svg": "ea06",
	"./us.svg": "7646",
	"./zh.svg": "6e94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c491";